<template>
  <el-scrollbar :native="false" style="width: 100%; height: 100%">
    <el-main>
      <el-card>
        <template #header>订单管理</template>
        <!--  style="display: flex; justify-content: space-between;" -->
        <div>
          <!-- <div> -->
          <el-input
            style="width: 200px; margin-right: 5px"
            placeholder="订单号"
            prefix-icon="el-icon-search"
            v-model="inputOrderId"
          ></el-input>
          <el-input style="width: 170px; margin-right: 5px" placeholder="手机号" prefix-icon="el-icon-search"
                    v-model="inputPhoneNumber"></el-input>
          <el-date-picker
            style="margin-right: 5px"
            :picker-options="pickerOptions"
            align="right"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            unlink-panels
            v-model="valueTime"
            value-format="yyyy-MM-dd"
          />
          <el-select v-model="orderPayStatus" placeholder="购买状态" style="margin-right: 5px; width: 150px"
                     @change="requestOrderList(true)">
            <el-option v-for="item in orderPayStatusType" :label="item.label" :value="item.value" :key="item.value"/>
          </el-select>
          <el-select v-model="orderPayType" placeholder="支付方式" style="margin-right: 5px"
                     @change="requestOrderList(true)">
            <el-option v-for="item in orderPayTypeType" :label="item.label" :value="item.value" :key="item.value"/>
          </el-select>
          <!-- 退款状态 -->
          <el-select v-model="refundStatus" placeholder="退款状态" style="margin-right: 5px; width: 150px"
                     @change="requestOrderList(true)">
            <el-option v-for="item in refundStatusList" :label="item.label" :value="item.value" :key="item.value"/>
          </el-select>
          <el-button @click="requestOrderList(true)" style="width: 150px; margin-right: 10px" type="primary">确定
          </el-button>
          <!-- </div> -->
          <el-button @click="readAllClick" style="width: 120px; height: 32px" type="warning">一建已读</el-button>
        </div>
      </el-card>
      <el-table
        ref="multipleTable"
        :data="orderList"
        tooltip-effect="dark"
        border
        style="width: 100%; margin-top: 20px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="orderId"
          label="订单编号"
          align="center"
          width="220"
        >
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.hasRead == 0" style="color: red; font-size: 20px"
              >*
              </span>
              <span>{{ row.orderId }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in orderListTitle"
          :key="index"
          :prop="item.propertyName"
          :label="item.name"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column align="center" width="270px" label="操作">
          <div slot-scope="scope">
            <el-button size="mini" @click="lookDetail(scope.row)">查看详情</el-button>
            <el-button size="mini" @click="subscription(scope.row)" v-if="scope.row.subscribeId">订阅器</el-button>
            <el-button size="mini" @click="invoice(scope.row)" v-if="scope.row.invoiceId">发票</el-button>
            <el-button v-if="scope.row.orderPayStatus == '未支付'" size="mini"
                       @click="handleEdit(scope.$index, scope.row)">确认到账
            </el-button>
            <el-button v-if="scope.row.orderPayStatus === '已支付'&&scope.row.refundStatus === '未退款'" size="mini"
                       @click="handleRefund(scope.row)">退款
            </el-button>
          </div>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[5, 10, 15, 20, 25, 30, 50, 100]" :page-size="listPageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="listPageTotal"></el-pagination>
      </div>
    </el-main>
    <subscriberDialog :visible.sync="dialogVisible" :before-close="handleClose" :info="subInfo"></subscriberDialog>
    <orderDetailDialog @update="requestOrderList" ref="detailDialog"></orderDetailDialog>
  </el-scrollbar>
</template>

<script>
import subscriberDialog from "@/components/subscriberDialog";
import orderDetailDialog from "@/components/orderDetailDialog";
import { orderRefund } from '@/utils/api'

export default {
  name: "backOrderManage",
  components: {
    subscriberDialog,
    orderDetailDialog,
  },
  data() {
    return {
      inputOrderId: "",
      inputPhoneNumber: "",
      orderPayStatus: "",
      orderPayType: "",
      inputKeyword: "",
      // 退款状态  null：全部  0：未退款 3：已退款
      refundStatus: null,
      multipleSelection: [],
      optionTimeInterval: [
        { value: "选项1", label: "一天内", },
        { value: "选项2", label: "两天内", },
        { value: "选项2", label: "三天内", },
        { value: "选项2", label: "一周内", },
        { value: "选项2", label: "一月内", },
      ],
      orderPayStatusType: [
        { label: "购买状态", value: "" },
        { label: "已取消", value: "-1" },
        { label: "未支付", value: "0" },
        { label: "已支付", value: "1" },
        { label: "订单失效", value: "2" },
      ],
      orderPayTypeType: [
        { label: "支付方式", value: "" },
        { label: "未知", value: 0 },
        { label: "在线支付", value: 16 }, //非转账和后台开通
        { label: "转账", value: 3 },
        { label: "微信扫码支付", value: 6 },
        { label: "微信jsapi支付", value: 7 },
        { label: "支付宝扫码", value: 8 },
        { label: "易找标后台开通", value: 12 },
        { label: "H5微信", value: 13 },
        { label: "H5支付宝", value: 14 },
        { label: "微信浏览器下的jsapi支付", value: 15 },
        { label: "易找标后台转账", value: 26 },
      ],
      refundStatusList: [
        { label: "退款状态", value: null },
        { label: "未退款", value: 0 },
        { label: "已退款", value: 3 },
      ],
      valueTimeInterval: "",
      valueEnclosure: "",
      inputMinFee: "",
      inputMaxFee: "",
      listPageSize: 10, //单页数据数
      listPageTotal: 0, //总数据数量
      listSize: 10, //总页数
      currentPage: 1, //当前页
      pickerOptions: {
        disabledDate: (time) => {
          return (function (time) {
            var times = Date.now();
            return time.getTime() > times;
          })(time);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      valueTime: [], //日期选择器区间
      orderListTitle: [
        { name: "名称", propertyName: "orderDescribe" },
        { name: "用户手机号", propertyName: "phoneNumber" },
        { name: "创建时间", propertyName: "orderCreateTime" },
        { name: "订单价格(元)", propertyName: "realMoney" },
        { name: "购买状态", propertyName: "orderPayStatus" },
        { name: "退款状态", propertyName: "refundStatus" },
        { name: "支付时间", propertyName: "orderPayTime" },
        { name: "支付方式", propertyName: "orderPayType" },
      ],
      orderList: [],
      dialogVisible: false, // 订阅器对话框
      subInfo: {}, //订阅器信息
      // 支付类型
      payTypeList: [
        "未知",
        "微信app",
        "支付宝app",
        "转账",
        "余额支付",
        "IOS内购",
        "微信扫码支付",
        "微信jsapi支付",
        "支付宝扫码",
        "对公转账",
        "10",
        "11",
        "易找标后台开通",
        "H5微信",
        "H5支付宝",
        "微信浏览器下的jsapi支付",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "易找标后台转账",
      ],
    };
  },
  mounted() {
    let loading = this.$loading(this.utils.defaultLoadingOptions);
    this.requestOrderList(true).then(
      () => {
        loading.close();
      },
      (err) => {
        console.log(err);
      }
    );
  },
  methods: {
    // 订单一键已读按钮点击事件
    async readAllClick() {
      if (!this.$store.state.orderNum) {
        this.$message.warning("暂无未读订单");
        return;
      }
      this.$confirm("此操作会将所有未读订单置为已读状态, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let { status } = await this.$request.clearOrderMessage();
          if (status !== 200) {
            this.$message.error("操作失败");
            return;
          }
          this.$message.success("操作成功");
          this.requestOrderList();
          await this.$store.dispatch("changeOrderNum");
        })
        .catch(() => {
        });
    },
    lookDetail({ id }) {
      this.$refs.detailDialog.open(id);
    },
    // 订阅器
    handleClose() {
      this.dialogVisible = false;
    },
    toggleSelection(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          console.log(this.$refs.multipleTable.toggleRowSelection);
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      //表格选中状态切换
      // console.log(val)
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.listPageSize = val;
      this.requestOrderList(true).then(() => {
        loading.close();
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.currentPage = val;
      this.requestOrderList().then(() => {
        loading.close();
      });
    },
    handleEdit(index, row) {
      this.$confirm(
        "此操作将把订单状态从未支付调整为【已支付】，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$request
            .orderPayDone({
              orderId: row.orderId,
            })
            .then(
              (res) => {
                if (res.status == 200) {
                  this.requestOrderList();
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                } else {
                  this.requestError(res.status, res.message);
                }
              },
              (err) => {
                this.requestFail(err);
              }
            );
        })
        .catch(() => {
        });
    },
    // 退款
    async handleRefund(row) {
      this.$confirm('确认要进行退款吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let [err] = await orderRefund(row.orderId, row.orderUserId)
        if (err) return
        this.$message.success('退款成功')
        await this.requestOrderList()
        this.$loading(this.utils.defaultLoadingOptions).close();
      }).catch(() => {
      })
    },

    // 订阅器
    subscription(row) {
      this.$request
        .findSubscribeByUserId(row.orderUserId)
        .then((res) => {
          this.dialogVisible = true;
          this.subInfo = res.data;
        })
        .catch();
    },
    // 发票
    invoice(row) {
      let { href } = this.$router.resolve({
        name: "backInvoiceTitleEdit",
        query: {
          id: row.invoiceId,
        },
      });
      window.open(href, "_blank");
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm("确认转账支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let loading = this.$loading(this.utils.defaultLoadingOptions);
          this.$request
            .deleteTenderingMessage({
              id: row.id,
            })
            .then(
              (res) => {
                console.log(res);
                loading.close();
                if (res.status == 200) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.requestTenderingMessageList();
                } else {
                  this.$message({
                    type: "info",
                    message: "删除失败！",
                  });
                  this.requestError(res.status, res.message);
                }
              },
              (err) => {
                console.log(err);
                loading.close();
                this.requestFail(err);
              }
            );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    batchDeletion() {
      //批量删除
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将删除选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let loading = this.$loading(this.utils.defaultLoadingOptions);
            let data = [];
            this.multipleSelection.forEach((item) => {
              data.push(item.orderId);
            });
            this.$request.deleteOrder(data).then(
              (res) => {
                loading.close();
                if (res.status == 200) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.requestOrderList();
                } else {
                  this.$message({
                    type: "info",
                    message: "删除失败！",
                  });
                  this.requestError(res.status, res.message);
                }
              },
              (err) => {
                console.log(err);
                loading.close();
                this.requestFail(err);
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$confirm("请至少选中一条数据！", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showCancelButton: false,
        });
      }
    },
    requestOrderList(reset = false) {
      if (reset) this.currentPage = 1;
      // console.log(data)
      return new Promise((resolve, reject) => {
        this.$request
          .orderList({
            orderId: this.inputOrderId.trim() ? this.inputOrderId.trim() : null,
            tel: this.inputPhoneNumber.trim()
              ? this.inputPhoneNumber.trim()
              : null,
            orderPayStatus: this.orderPayStatus,
            orderPayType: this.orderPayType,
            refundStatus: this.refundStatus,
            keywords: this.inputKeyword.trim()
              ? [this.inputKeyword.trim()]
              : null,
            startTime:
              this.valueTime && this.valueTime[0] ? this.valueTime[0] : null,
            endTime:
              this.valueTime && this.valueTime[1] ? this.valueTime[1] : null,
            minMoney: this.inputMinFee.trim()
              ? this.inputMinFee.trim() * 100
              : null, //起始金额
            maxMoney: this.inputMaxFee.trim()
              ? this.inputMaxFee.trim() * 100
              : null, //最高金额
            page: this.currentPage,
            size: this.listPageSize,
          })
          .then(
            (res) => {
              if (res.status == 200) {
                resolve(res);
                res.data.list.forEach((item) => {
                  item.realMoney = (item.cashFee / 100).toFixed(2);
                  item.orderPayTime = (item.orderPayStatus == 0 || item.orderPayStatus == -1) ? "--" : item.orderPayTime;
                  item.orderPayType = (item.orderPayStatus == 0 || item.orderPayStatus == -1) ? "--" : this.payTypeList[item.orderPayType];
                  item.refundStatus = (item.orderPayStatus == 0 || item.orderPayStatus == -1) ? "--" :  (item.refundStatus == 3 ? '已退款' : '未退款');
                  item.orderPayStatus =
                    item.orderPayStatus == -1
                      ? "已取消"
                      : item.orderPayStatus == 0
                        ? "未支付"
                        : item.orderPayStatus == 1
                          ? "已支付"
                          : item.orderPayStatus == 2
                            ? "订单失效"
                            : item.orderPayStatus == 3
                              ? "部分支付"
                              : "-";
                  item.invoiceStatus =
                    item.invoiceStatus == 1 ? "已申请" : "未申请";
                  
                  
                });
                this.orderList = res.data.list;
                this.listPageTotal = res.data.total;
              } else {
                this.requestError(res.status, res.message);
              }
            },
            (err) => {
              reject(err);
              this.requestFail(err);
            }
          );
      });
    },
  },
};
</script>

<style scoped lang="less">
#container {
  .screen-form {
    margin-bottom: 20px;
  }

  .pagination-wrap {
    margin-top: 50px;
  }
}
</style>
